function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8889 19.9998C11.9122 20.0097 10.9617 19.6835 10.1969 19.0758C9.79126 18.7213 9.73932 18.1092 10.0795 17.6914C10.4196 17.2736 11.0296 17.2004 11.4589 17.5258C11.8674 17.8425 12.3721 18.0098 12.8889 17.9998C13.9729 17.9998 14.8889 17.3138 14.8889 16.4998C14.8889 15.6858 13.9729 14.9998 12.8889 14.9998C10.822 15.1257 9.03847 13.5652 8.88892 11.4998C9.03847 9.43442 10.822 7.87386 12.8889 7.99979C13.8657 7.98989 14.8161 8.31613 15.5809 8.92379C15.8723 9.14459 16.0199 9.50679 15.966 9.86837C15.912 10.2299 15.6651 10.5333 15.3219 10.6594C14.9788 10.7855 14.5942 10.7143 14.3189 10.4738C13.9104 10.157 13.4057 9.98975 12.8889 9.99979C11.8049 9.99979 10.8889 10.6858 10.8889 11.4998C10.8889 12.3138 11.8049 12.9998 12.8889 12.9998C14.9559 12.8739 16.7394 14.4344 16.8889 16.4998C16.7394 18.5652 14.9559 20.1257 12.8889 19.9998Z",
  fill: "#F8D635"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8889 10C12.3366 10 11.8889 9.55228 11.8889 9V7C11.8889 6.44772 12.3366 6 12.8889 6C13.4412 6 13.8889 6.44772 13.8889 7V9C13.8889 9.55228 13.4412 10 12.8889 10Z",
  fill: "#F8D635"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8889 22C12.3366 22 11.8889 21.5523 11.8889 21V19C11.8889 18.4477 12.3366 18 12.8889 18C13.4412 18 13.8889 18.4477 13.8889 19V21C13.8889 21.5523 13.4412 22 12.8889 22Z",
  fill: "#F8D635"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5729 29.9478C12.6747 29.982 12.7814 29.9996 12.8889 29.9998C12.993 29.9985 13.0962 29.981 13.1949 29.9478C25.0049 26.0098 24.9569 20.8538 24.8889 13.7158V4.99981C24.889 4.5793 24.626 4.20363 24.2309 4.05981L13.2309 0.0598118C13.01 -0.0205883 12.7678 -0.0205883 12.5469 0.0598118L1.54689 4.05981C1.15173 4.20363 0.888764 4.5793 0.88889 4.99981V13.7158C0.81089 20.8538 0.76489 26.0118 12.5729 29.9478ZM2.88889 13.7358V5.69981L12.8889 2.06381L22.8889 5.69981V13.7358C22.9649 20.6438 23.0009 24.4878 12.8889 27.9358C2.78689 24.4958 2.82289 20.6538 2.88889 13.7358Z",
  fill: "#F8D635"
});

var SvgBenefits1 = function SvgBenefits1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBenefits1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/benefits1.3cac89e1.svg";
export { ForwardRef as ReactComponent };